import styled from "styled-components/macro";

import { colors, fontSize, fontStyle } from "shared/styles/constants";
import { IStatus } from "shared/types";
import { FontFamily, borderRadius, space } from "shared/styles/constants";

export const MutedText = styled.span`
  color: ${colors.grey5};
`;

export const MutedDarkText = styled.span`
  color: ${colors.grey4};
`;

export const MutedDarkTextWithMargin = styled(MutedDarkText)`
  margin-left: 4px !important;
`;

export const BlackText = styled.span`
  color: ${colors.black};
`;

export const BoldText = styled.span`
  ${fontStyle.bold}
`;

export const CenteredText = styled.div`
  text-align: center;
`;

export const ItalicText = styled.span`
  ${fontStyle.italic}
`;

export const SmallText = styled.span`
  ${fontSize.xs}

  ul {
    list-style: disc;

    li {
      margin-left: 1rem;
    }
  }

  ol {
    list-style: decimal;

    li {
      margin-left: 1rem;
    }
  }
`;

export const CodeText = styled.code`
  display: inline;

  background-color: ${colors.white5};
  border-radius: ${borderRadius.s};
  padding: ${space.xxs};

  color: ${colors.grey5};
  font-family: ${FontFamily.mono};
  font-weight: 500;
`;

export const TinyText = styled.span`
  text-transform: uppercase;
  ${fontStyle.bold}
  ${fontSize.xxs}
  letter-spacing: 1px;
`;

export const ExtraTinyText = styled.span`
  text-transform: uppercase;
  ${fontStyle.bold}
  font-size: 8px;
  line-height: 1.2;
`;

export const UppercaseText = styled.span`
  text-transform: uppercase;
`;

export const Paragraph = styled.p``;

interface StatusTextProps {
  status?: IStatus;
}

const getStatusColor = (status?: IStatus): colors | string => {
  switch (status) {
    case IStatus.success:
      return colors.green;
    case IStatus.warning:
      return colors.yellow;
    case IStatus.error:
      return colors.red;
    default:
      return "currentColor";
  }
};

export const StatusText = styled.span<StatusTextProps>`
  color: ${({ status }) => getStatusColor(status)};

  @media print {
    color: ${getStatusColor(IStatus.error)} !important;
  }
`;
